<template>
  <iframe
    v-if="$store.getters.appConfig"
    :src="
      $store.getters.appConfig.url +
      '/redirect-manager/admin.html?ts=' +
      Date.now()
    "
  >
  </iframe>
</template>
<script>
import { mapActions } from "vuex";

export default {
  name: "RedirectPage",
  methods: {
    ...mapActions(["getLanguages", "getApps", "setApp", "setCmsApp"]),
  },
  async beforeMount() {
    if (this.$store.getters.apps == null) await this.getApps();

    this.$store.getters.apps.forEach(async (a) => {
      if (a.id == this.$route.params.id) {
        this.setApp(a.token);
        this.setCmsApp(a.token);
        this.app = a;
        if (this.app.token !== "cciporto") this.getLanguages();
      }
    });
    this.$parent.$parent.transition = false;
  },
};
</script>
<style scoped>
iframe {
  width: 100%;
  height: calc(100% - 64px);
}
</style>
